fragment ContactSearchResult on Contact {
    id
    type
    name: htmlName
    description
    initials
    htmlUrlPath
    avatarUrl
    accounts {
        primary {
            name
        }
    }
    phones {
        primary {
            value {
                numberFormatted
            }
        }
    }
    emailAddresses {
        primary {
            value {
                address
            }
        }
    }
}
